import http from '@/assets/js/interceptor';

/**
 * 通过拖拽验证码发送短信
 * @param data.captchaVerification {String} 拖拽验证码
 * @param data.mobile {String} 手机号
 * @returns {AxiosPromise<any>}
 */
export function sendSmsCodeByVerifyApi (data) {
  return http.post('/v1/login/sms_send', data);
}

/**
 * 登录 通过拖拽验证码
 * @param data
 * @returns {AxiosPromise<any>}
 */
export function loginByVerifyApi (data) {
  return http.post('/v1/login/auth', data);
}
